import React, { useRef, useState } from "react";
import { Card, CardBody, CardTitle, Button, Row, Col } from "reactstrap";
import "./css/gallery.css";
import Sannam from "./products/Sannam";
import FormComponent from "./form";
import ChilliDescription from "./chilliDescription";

export const Gallery = (props) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [descriptionClicked, setDescriptionClicked] = useState({
    clicked: false,
    productName: "",
  });
  const [productName, setProductName] = useState("");
  const [hoveredCard, setHoveredCard] = useState(null); // Track hovered card

  // Refs for scrolling to components
  const detailsRef = useRef(null);
  const descriptionRef = useRef(null);
  const formRef = useRef(null);

  const handleViewDetails = (item) => {
    setSelectedItem(item);
    setDescriptionClicked({ clicked: false, productName: "" });
    setProductName("");
    detailsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleDescriptionClick = (productName) => {
    setDescriptionClicked({ clicked: true, productName });
    setSelectedItem(null);
    setProductName("");
    descriptionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handlePlaceOrder = (productName) => {
    setProductName(productName);
    setSelectedItem(null);
    setDescriptionClicked({ clicked: false, productName: "" });
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Gallery</h2>
          <h5>
            Explore our collection of premium dry red chillies known for their
            unique flavors and spice levels.
          </h5>
        </div>
        <Row>
          {props.data.map((item, index) => (
            <Col xs="12" sm="6" md="4" lg="3" className="mb-4" key={index}>
              <Card
                className="gallery-card"
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="image-container">
                  <img
                    alt={item.title}
                    src={item.src}
                    className="gallery-image"
                  />
                  {hoveredCard === index && ( // Show buttons only on hover
                    <div className="button-overlay">
                      <Button
                        style={{ backgroundColor: "maroon" }}
                        color="primary"
                        className="gallery-button"
                        onClick={() => handleViewDetails(item)}
                      >
                        Details
                      </Button>{" "}
                      <Button
                        color="primary"
                        className="gallery-button"
                        onClick={() => handleDescriptionClick(item.title)}
                      >
                        Descriptions
                      </Button>{" "}
                      <Button
                        color="success"
                        className="gallery-button"
                        onClick={() => handlePlaceOrder(item.title)}
                      >
                        Order
                      </Button>
                    </div>
                  )}
                </div>
                <CardBody>
                  <CardTitle tag="h5" className="gallery-title">
                    {item.title}
                  </CardTitle>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <div ref={detailsRef}>
        {selectedItem && <Sannam product={selectedItem} />}
      </div>
      <div ref={descriptionRef}>
        {descriptionClicked.clicked && (
          <ChilliDescription descriptions={descriptionClicked} />
        )}
      </div>
      <div ref={formRef}>
        {productName && (
          <FormComponent
            productName={productName}
            setFormComponentClicked={() => setProductName("")}
          />
        )}
      </div>
    </div>
  );
};
